/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
} from './Pagination';
import type { SAPOrderAttachment } from './SAPOrderAttachment';
import {
    SAPOrderAttachmentFromJSON,
    SAPOrderAttachmentFromJSONTyped,
    SAPOrderAttachmentToJSON,
} from './SAPOrderAttachment';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * Representation of a search result for Order Attachment metadata
 * @export
 * @interface SAPOrderAttachmentList
 */
export interface SAPOrderAttachmentList {
    /**
     * list of Order Attachment objects
     * @type {Array<SAPOrderAttachment>}
     * @memberof SAPOrderAttachmentList
     */
    sapAttachments?: Array<SAPOrderAttachment>;
    /**
     * sorting information
     * @type {Array<Sort>}
     * @memberof SAPOrderAttachmentList
     */
    sorts?: Array<Sort>;
    /**
     * 
     * @type {Pagination}
     * @memberof SAPOrderAttachmentList
     */
    pagination?: Pagination;
}

/**
 * Check if a given object implements the SAPOrderAttachmentList interface.
 */
export function instanceOfSAPOrderAttachmentList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SAPOrderAttachmentListFromJSON(json: any): SAPOrderAttachmentList {
    return SAPOrderAttachmentListFromJSONTyped(json, false);
}

export function SAPOrderAttachmentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): SAPOrderAttachmentList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sapAttachments': !exists(json, 'sapAttachments') ? undefined : ((json['sapAttachments'] as Array<any>).map(SAPOrderAttachmentFromJSON)),
        'sorts': !exists(json, 'sorts') ? undefined : ((json['sorts'] as Array<any>).map(SortFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : PaginationFromJSON(json['pagination']),
    };
}

export function SAPOrderAttachmentListToJSON(value?: SAPOrderAttachmentList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sapAttachments': value.sapAttachments === undefined ? undefined : ((value.sapAttachments as Array<any>).map(SAPOrderAttachmentToJSON)),
        'sorts': value.sorts === undefined ? undefined : ((value.sorts as Array<any>).map(SortToJSON)),
        'pagination': PaginationToJSON(value.pagination),
    };
}

